import { render, staticRenderFns } from "./aboutBanner.vue?vue&type=template&id=249ecd82&scoped=true&"
import script from "./aboutBanner.vue?vue&type=script&lang=js&"
export * from "./aboutBanner.vue?vue&type=script&lang=js&"
import style1 from "./aboutBanner.vue?vue&type=style&index=1&id=249ecd82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249ecd82",
  null
  
)

export default component.exports